import { useEffect, useState } from "react";
import { Alert, Loading } from "../components/Card";
import { TotpPolicyCard } from "../components/Totp";
import { authApi, authErrText } from "../lib/auth";
import type { TotpPolicy } from "../lib/auth";
import { tx } from "../i18n";

/* ══ 설정 › 로그인 · 2단계(관리자만) — 공통 ④(Figma 92-215) 왼쪽 아래 ══
   값은 셋뿐이고 판정은 관문이 요청마다 한다(`crates/api/src/auth.rs`). 켜는 순간 등록 전인
   세션은 **다음 요청부터** 등록 화면으로 간다 — 이 화면을 연 관리자 자신도 그렇다. */
export function AuthPolicySection() {
  const [saved, setSaved] = useState<TotpPolicy | null>(null);
  const [loadErr, setLoadErr] = useState<string | null>(null);

  useEffect(() => {
    authApi
      .totpPolicy()
      .then((r) => setSaved(r.policy))
      .catch((e) => setLoadErr(authErrText(e)));
  }, []);

  return (
    <>
      <h2>{tx("policy.title")}</h2>
      <p className="muted">{tx("policy.lead")}</p>
      {loadErr ? <Alert tone="error">{tx("policy.loadFailed", { err: loadErr })}</Alert> : null}
      {saved ? (
        <div className="acctgrid">
          <TotpPolicyCard
            key={saved}
            saved={saved}
            onSave={async (p) => {
              const r = await authApi.setTotpPolicy(p);
              setSaved(r.policy);
            }}
          />
        </div>
      ) : !loadErr ? (
        <Loading text={tx("policy.loading")} />
      ) : null}
    </>
  );
}
